import React from "react";
import PropTypes from "prop-types";
//import material-ui components
import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
//import material icons
import Close from "@material-ui/icons/Close";
//import core components
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput";

import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

class OrganizationDialog extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            waterAmount: "0",
        };
    }

    componentWillReceiveProps(nextProps){
        if (!this.props.isOpened && nextProps.isOpened){
            this.setState({
                waterAmount: nextProps.waterAmount ? nextProps.waterAmount: "0",
            })
        }
        if (this.props.isOpened && !nextProps.isOpened){
            this.setState({
                waterAmount: "0",
            })
        }
    }

    _changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state)
    }

    render(){
        const { classes, onCancel, onSave, isOpened } = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={isOpened}
                onClose={() => onCancel()}
            >
                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}
                >
                    <IconButton
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={() => onCancel()}
                    >
                        <Close className={classes.modalClose} />
                    </IconButton>
                    <h4 className={classes.modalTitle} >Изменить количсество воды с заправки</h4>
                </DialogTitle>
                <DialogContent className={classes.modalBody}>
                    <Grid container>
                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Воды с заправки"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.waterAmount,
                                    onChange: e => this._changeValue(e, "waterAmount")
                                }}
                            />
                        </GridItem>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.modalFooter} >
                    <Button color="primary"
                            onClick={() => onSave(this.state.waterAmount)}
                    >
                        Сохранить
                    </Button>
                    <Button color="primary" simple
                            onClick={() => onCancel()}
                    >
                        Отменить
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

OrganizationDialog.propTypes = {
    isOpened: PropTypes.bool,
    waterAmount: PropTypes.number,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
};

export default withStyles(modalStyle)(OrganizationDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/MachineWaterChangeDialog.jsx